(function () {
  'use strict';

  var DIAL_CODES = {
    AF:93, AL:355, DZ:213, AS:1, AD:376, AO:244, AI:1, AG:1, AR:54, AM:374, AW:297, AU:61, AT:43, AZ:994,
    BS:1, BH:973, BD:880, BB:1, BY:375, BE:32, BZ:501, BJ:229, BM:1, BT:975, BO:591, BA:387, BW:267, BR:55,
    BN:673, BG:359, BF:226, BI:257, KH:855, CM:237, CA:1, CV:238, KY:1, CF:236, TD:235, CL:56, CN:86, CO:57,
    KM:269, CG:242, CD:243, CK:682, CR:506, CI:225, HR:385, CU:53, CW:599, CY:357, CZ:420, DK:45, DJ:253,
    DM:1, DO:1, EC:593, EG:20, SV:503, GQ:240, ER:291, EE:372, SZ:268, ET:251, FJ:679, FI:358, FR:33, GF:594,
    PF:689, GA:241, GM:220, GE:995, DE:49, GH:233, GI:350, GR:30, GL:299, GD:1, GP:590, GU:1, GT:502, GN:224,
    GW:245, GY:592, HT:509, HN:504, HK:852, HU:36, IS:354, IN:91, ID:62, IR:98, IQ:964, IE:353, IM:44, IL:972,
    IT:39, JM:1, JP:81, JE:44, JO:962, KZ:7, KE:254, KI:686, KW:965, KG:996, LA:856, LV:371, LB:961, LS:266,
    LR:231, LY:218, LI:423, LT:370, LU:352, MO:853, MG:261, MW:265, MY:60, MV:960, ML:223, MT:356, MH:692,
    MQ:596, MR:222, MU:230, YT:262, MX:52, FM:691, MD:373, MC:377, MN:976, ME:382, MS:1, MA:212, MZ:258,
    MM:95, NA:264, NR:674, NP:977, NL:31, NC:687, NZ:64, NI:505, NE:227, NG:234, NU:683, NF:672, KP:850,
    MK:389, MP:1, NO:47, OM:968, PK:92, PW:680, PS:970, PA:507, PG:675, PY:595, PE:51, PH:63, PL:48, PT:351,
    PR:1, QA:974, RE:262, RO:40, RU:7, RW:250, KN:1, LC:1, PM:508, VC:1, WS:685, SM:378, ST:239, SA:966,
    SN:221, RS:381, SC:248, SL:232, SG:65, SX:1, SK:421, SI:386, SB:677, SO:252, ZA:27, KR:82, SS:211, ES:34,
    LK:94, SD:249, SR:597, SE:46, CH:41, SY:963, TW:886, TJ:992, TZ:255, TH:66, TL:670, TG:228, TK:690,
    TO:676, TT:1, TN:216, TR:90, TM:993, TC:1, TV:688, UG:256, UA:380, AE:971, GB:44, US:1, UY:598, UZ:998,
    VU:678, VA:379, VE:58, VN:84, VG:1, VI:1, WF:681, YE:967, ZM:260, ZW:263
  };
  var COUNTRY_NAMES = {
    AF:'Afghanistan', AL:'Albania', DZ:'Algeria', AS:'American Samoa', AD:'Andorra', AO:'Angola', AI:'Anguilla',
    AG:'Antigua and Barbuda', AR:'Argentina', AM:'Armenia', AW:'Aruba', AU:'Australia', AT:'Austria', AZ:'Azerbaijan',
    BS:'Bahamas', BH:'Bahrain', BD:'Bangladesh', BB:'Barbados', BY:'Belarus', BE:'Belgium', BZ:'Belize', BJ:'Benin',
    BM:'Bermuda', BT:'Bhutan', BO:'Bolivia', BA:'Bosnia and Herzegovina', BW:'Botswana', BR:'Brazil', BN:'Brunei',
    BG:'Bulgaria', BF:'Burkina Faso', BI:'Burundi', KH:'Cambodia', CM:'Cameroon', CA:'Canada', CV:'Cape Verde',
    KY:'Cayman Islands', CF:'Central African Republic', TD:'Chad', CL:'Chile', CN:'China', CO:'Colombia',
    KM:'Comoros', CG:'Congo', CD:'Congo (DRC)', CK:'Cook Islands', CR:'Costa Rica', CI:"Côte d'Ivoire",
    HR:'Croatia', CU:'Cuba', CW:'Curaçao', CY:'Cyprus', CZ:'Czech Republic', DK:'Denmark', DJ:'Djibouti',
    DM:'Dominica', DO:'Dominican Republic', EC:'Ecuador', EG:'Egypt', SV:'El Salvador', GQ:'Equatorial Guinea',
    ER:'Eritrea', EE:'Estonia', SZ:'Eswatini', ET:'Ethiopia', FJ:'Fiji', FI:'Finland', FR:'France',
    GF:'French Guiana', PF:'French Polynesia', GA:'Gabon', GM:'Gambia', GE:'Georgia', DE:'Germany', GH:'Ghana',
    GI:'Gibraltar', GR:'Greece', GL:'Greenland', GD:'Grenada', GP:'Guadeloupe', GU:'Guam', GT:'Guatemala',
    GN:'Guinea', GW:'Guinea-Bissau', GY:'Guyana', HT:'Haiti', HN:'Honduras', HK:'Hong Kong', HU:'Hungary',
    IS:'Iceland', IN:'India', ID:'Indonesia', IR:'Iran', IQ:'Iraq', IE:'Ireland', IM:'Isle of Man', IL:'Israel',
    IT:'Italy', JM:'Jamaica', JP:'Japan', JE:'Jersey', JO:'Jordan', KZ:'Kazakhstan', KE:'Kenya', KI:'Kiribati',
    KW:'Kuwait', KG:'Kyrgyzstan', LA:'Laos', LV:'Latvia', LB:'Lebanon', LS:'Lesotho', LR:'Liberia', LY:'Libya',
    LI:'Liechtenstein', LT:'Lithuania', LU:'Luxembourg', MO:'Macau', MG:'Madagascar', MW:'Malawi', MY:'Malaysia',
    MV:'Maldives', ML:'Mali', MT:'Malta', MH:'Marshall Islands', MQ:'Martinique', MR:'Mauritania', MU:'Mauritius',
    YT:'Mayotte', MX:'Mexico', FM:'Micronesia', MD:'Moldova', MC:'Monaco', MN:'Mongolia', ME:'Montenegro',
    MS:'Montserrat', MA:'Morocco', MZ:'Mozambique', MM:'Myanmar', NA:'Namibia', NR:'Nauru', NP:'Nepal',
    NL:'Netherlands', NC:'New Caledonia', NZ:'New Zealand', NI:'Nicaragua', NE:'Niger', NG:'Nigeria', NU:'Niue',
    NF:'Norfolk Island', KP:'North Korea', MK:'North Macedonia', MP:'Northern Mariana Islands', NO:'Norway',
    OM:'Oman', PK:'Pakistan', PW:'Palau', PS:'Palestine', PA:'Panama', PG:'Papua New Guinea', PY:'Paraguay',
    PE:'Peru', PH:'Philippines', PL:'Poland', PT:'Portugal', PR:'Puerto Rico', QA:'Qatar', RE:'Réunion',
    RO:'Romania', RU:'Russia', RW:'Rwanda', KN:'Saint Kitts and Nevis', LC:'Saint Lucia', PM:'Saint Pierre and Miquelon',
    VC:'Saint Vincent and the Grenadines', WS:'Samoa', SM:'San Marino', ST:'São Tomé and Príncipe',
    SA:'Saudi Arabia', SN:'Senegal', RS:'Serbia', SC:'Seychelles', SL:'Sierra Leone', SG:'Singapore', SX:'Sint Maarten',
    SK:'Slovakia', SI:'Slovenia', SB:'Solomon Islands', SO:'Somalia', ZA:'South Africa', KR:'South Korea',
    SS:'South Sudan', ES:'Spain', LK:'Sri Lanka', SD:'Sudan', SR:'Suriname', SE:'Sweden', CH:'Switzerland',
    SY:'Syria', TW:'Taiwan', TJ:'Tajikistan', TZ:'Tanzania', TH:'Thailand', TL:'Timor-Leste', TG:'Togo',
    TK:'Tokelau', TO:'Tonga', TT:'Trinidad and Tobago', TN:'Tunisia', TR:'Turkey', TM:'Turkmenistan',
    TC:'Turks and Caicos Islands', TV:'Tuvalu', UG:'Uganda', UA:'Ukraine', AE:'United Arab Emirates',
    GB:'United Kingdom', US:'United States', UY:'Uruguay', UZ:'Uzbekistan', VU:'Vanuatu', VA:'Vatican City',
    VE:'Venezuela', VN:'Vietnam', VG:'British Virgin Islands', VI:'U.S. Virgin Islands', WF:'Wallis and Futuna',
    YE:'Yemen', ZM:'Zambia', ZW:'Zimbabwe'
  };
  var PRIMARY_FOR_DIAL = { "1": "US", "7": "RU" };

  function zonedTodayAsLocalDate(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var y = Number(parts.find(function (p) { return p.type === 'year'; }).value);
      var m = Number(parts.find(function (p) { return p.type === 'month'; }).value);
      var dd = Number(parts.find(function (p) { return p.type === 'day'; }).value);
      return new Date(y, m - 1, dd);
    } catch (e) {
      var d = new Date(); d.setHours(0, 0, 0, 0); return d;
    }
  }

  function findCountryByDial(digitsOnly) {
    for (var len = 4; len >= 1; len--) {
      var candidate = digitsOnly.slice(0, len);
      var matches = Object.keys(DIAL_CODES).filter(function (cc) { return String(DIAL_CODES[cc]) === candidate; });
      if (matches.length) {
        var country = matches.length === 1 ? matches[0] : (PRIMARY_FOR_DIAL[candidate] || matches[0]);
        return { country: country, dial: candidate };
      }
    }
    return null;
  }

  function initForm(root) {
    var formType = root.getAttribute('data-form-type') || 'consultation_booking';
    var endpoint = root.getAttribute('data-worker-endpoint').replace(/\/?$/, '');

    var cfg = {
      slotMinutes: parseInt(root.getAttribute('data-slot-minutes'), 10) || 30,
      startHour: parseInt(root.getAttribute('data-start-hour'), 10) || 10,
      endHour: parseInt(root.getAttribute('data-end-hour'), 10) || 19,
      daysAhead: parseInt(root.getAttribute('data-days-ahead'), 10) || 14,
      skipWeekday: parseInt(root.getAttribute('data-skip-weekday'), 10),
      minLeadMinutes: parseInt(root.getAttribute('data-min-lead-minutes'), 10) || 60,
      businessTz: root.getAttribute('data-business-tz') || 'Asia/Kolkata'
    };
    var cfgQuery = 'slot_minutes=' + cfg.slotMinutes
      + '&start_hour=' + cfg.startHour
      + '&end_hour=' + cfg.endHour
      + '&min_lead_minutes=' + cfg.minLeadMinutes
      + '&business_tz=' + encodeURIComponent(cfg.businessTz);

    // ---- Phase 1 options (all driven by the Shopify theme Customizer via data-attributes) ----
    function flag(attr, dflt) {
      var v = root.getAttribute(attr);
      if (v === null || v === '') return dflt;
      return v === 'true';
    }
    var ui = {
      groupSlots: flag('data-group-slots', true),
      hideBooked: flag('data-hide-booked', true),
      showNext: flag('data-show-next', true),
      liveValidation: flag('data-live-validation', true),
      showAddToCal: flag('data-show-add-to-calendar', true),
      calTitle: root.getAttribute('data-cal-title') || 'HearSilk Hearing Consultation'
    };
    var specialist = {
      name: root.getAttribute('data-specialist-name') || '',
      title: root.getAttribute('data-specialist-title') || ''
    };
    var myBookingOn = flag('data-my-booking', true);
    var MB_KEY = 'hs_consult_booking_v1';
    var cameFromLink = false;
    // Opened from the "Open my booking" email link on any device: remember the booking on THIS device.
    try {
      var linkUrl = new URL(window.location.href);
      var linkTok = linkUrl.searchParams.get('hs_manage');
      if (linkTok && /^[a-f0-9]{32}$/.test(linkTok)) {
        try { localStorage.setItem('hs_consult_booking_v1', JSON.stringify({ token: linkTok, saved: Date.now() })); } catch (e2) {}
        cameFromLink = true;
        linkUrl.searchParams.delete('hs_manage');
        window.history.replaceState(null, '', linkUrl.pathname + linkUrl.search + linkUrl.hash);
      }
    } catch (e) {}
    function mbGet() { try { var v = localStorage.getItem(MB_KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
    function mbSet(o) { try { localStorage.setItem(MB_KEY, JSON.stringify(o)); } catch (e) {} }
    function mbClear() { try { localStorage.removeItem(MB_KEY); } catch (e) {} }
    var manageSettings = {
      allow_self_manage: flag('data-allow-manage', true),
      cutoff_hours: parseInt(root.getAttribute('data-manage-cutoff'), 10),
      max_reschedules: parseInt(root.getAttribute('data-max-reschedules'), 10),
      reminder_24h: flag('data-remind-24h', true),
      reminder_1h: flag('data-remind-1h', true),
      reminder_note: root.getAttribute('data-remind-note') || ''
    };
    if (isNaN(manageSettings.cutoff_hours)) delete manageSettings.cutoff_hours;
    if (isNaN(manageSettings.max_reschedules)) delete manageSettings.max_reschedules;

    var form = root.querySelector('[data-consultform-form]');
    var errorEl = root.querySelector('[data-consultform-error]');
    var submitBtn = root.querySelector('[data-consultform-submit]');
    var bodyEl = root.querySelector('[data-consultform-body]');
    var successEl = root.querySelector('[data-consultform-success]');
    var calRoot = root.querySelector('[data-calendar]');
    var slotHiddenInput = root.querySelector('[data-slot-value]');
    var slotSummary = root.querySelector('[data-slot-summary]');
    var dtTrigger = root.querySelector('[data-dt-trigger]');
    var dtLabel = root.querySelector('[data-dt-label]');
    var dtModal = root.querySelector('[data-dt-modal]');
    var dtClose = root.querySelector('[data-dt-close]');
    var nextAvailBtn = root.querySelector('[data-next-avail]');
    var slotCard = root.querySelector('[data-slot-card]');

    var visitorTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    var selectedSlotUtc = null;
    var selectedDateObj = null;
    var viewMonth = zonedTodayAsLocalDate(visitorTz);
    viewMonth.setDate(1);

    fetch(endpoint + '/timezone')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.timezone) visitorTz = data.timezone;
        if (data && data.country) applyDialCode(data.country);
      })
      .catch(function () {})
      .finally(function () { renderCalendar(); loadNextAvailable(); loadMyBooking(); });

    // ---------- Modal open/close ----------
    dtTrigger.addEventListener('click', function () { dtModal.hidden = false; });
    dtClose.addEventListener('click', function () { dtModal.hidden = true; });
    dtModal.addEventListener('click', function (e) { if (e.target === dtModal) dtModal.hidden = true; });

    // ---------- Phone country combo ----------
    var phoneCombo = root.querySelector('[data-consult-phone-combo]');
    var phoneTrigger = root.querySelector('[data-consult-phone-trigger]');
    var phoneTriggerFlag = root.querySelector('[data-consult-phone-flag]');
    var phoneTriggerCode = root.querySelector('[data-consult-phone-code]');
    var phoneDropdown = root.querySelector('[data-consult-phone-dropdown]');
    var phoneSearchInput = root.querySelector('[data-consult-phone-search]');
    var phoneList = root.querySelector('[data-consult-phone-list]');
    var phoneLocalInput = root.querySelector('[data-consult-phone-local]');
    var currentDialCountry = 'US';

    function applyDialCode(countryCode) {
      var cc = DIAL_CODES[countryCode] !== undefined ? countryCode : 'US';
      currentDialCountry = cc;
      if (phoneTriggerFlag) phoneTriggerFlag.className = 'fi fi-' + cc.toLowerCase();
      if (phoneTriggerCode) phoneTriggerCode.textContent = '+' + DIAL_CODES[cc];
      if (phoneList) {
        Array.prototype.forEach.call(phoneList.querySelectorAll('.hs-phone-item'), function (item) {
          item.setAttribute('data-active', item.getAttribute('data-country') === cc ? 'true' : 'false');
        });
      }
    }

    function buildPhoneList(filterText) {
      if (!phoneList) return;
      var q = (filterText || '').trim().toLowerCase();
      phoneList.innerHTML = '';
      var matches = Object.keys(COUNTRY_NAMES).filter(function (cc) {
        if (!q) return true;
        var name = COUNTRY_NAMES[cc].toLowerCase();
        var dial = DIAL_CODES[cc];
        return name.indexOf(q) !== -1 || cc.toLowerCase().indexOf(q) !== -1 || ('+' + dial).indexOf(q) !== -1 || String(dial).indexOf(q) !== -1;
      }).sort(function (a, b) { return COUNTRY_NAMES[a].localeCompare(COUNTRY_NAMES[b]); });

      if (!matches.length) {
        phoneList.innerHTML = '<div class="hs-phone-empty">No matches</div>';
        return;
      }
      matches.forEach(function (cc) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'hs-phone-item';
        item.setAttribute('data-country', cc);
        if (cc === currentDialCountry) item.setAttribute('data-active', 'true');
        item.innerHTML = '<span class="fi fi-' + cc.toLowerCase() + '"></span>' +
          '<span class="hs-phone-item-name">' + COUNTRY_NAMES[cc] + '</span>' +
          '<span class="hs-phone-item-dial">+' + DIAL_CODES[cc] + '</span>';
        item.addEventListener('mousedown', function (e) {
          e.preventDefault();
          applyDialCode(cc);
          closePhoneDropdown();
          phoneLocalInput.focus();
        });
        phoneList.appendChild(item);
      });
    }

    function openPhoneDropdown() {
      if (!phoneDropdown) return;
      phoneDropdown.hidden = false;
      phoneDropdown.style.left = '';
      phoneDropdown.style.right = '';
      phoneTrigger.setAttribute('aria-expanded', 'true');
      buildPhoneList('');
      if (phoneSearchInput) {
        phoneSearchInput.value = '';
        setTimeout(function () { phoneSearchInput.focus(); }, 30);
      }
      // Keep the dropdown inside the viewport — flip to right-aligned if it would overflow
      requestAnimationFrame(function () {
        var rect = phoneDropdown.getBoundingClientRect();
        if (rect.right > window.innerWidth - 8) {
          phoneDropdown.style.left = 'auto';
          phoneDropdown.style.right = '0';
        }
      });
    }
    function closePhoneDropdown() {
      if (!phoneDropdown) return;
      phoneDropdown.hidden = true;
      phoneTrigger.setAttribute('aria-expanded', 'false');
    }

    if (phoneTrigger) {
      phoneTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (phoneDropdown.hidden) openPhoneDropdown(); else closePhoneDropdown();
      });
    }
    if (phoneSearchInput) {
      phoneSearchInput.addEventListener('input', function () { buildPhoneList(phoneSearchInput.value); });
    }
    document.addEventListener('click', function (e) {
      if (phoneCombo && !phoneCombo.contains(e.target)) closePhoneDropdown();
    });

    applyDialCode('US'); // default while the /timezone fetch above resolves and geo-detects the real country

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && phoneDropdown && !phoneDropdown.hidden) closePhoneDropdown();
    });

    if (phoneLocalInput) {
      phoneLocalInput.addEventListener('input', function () {
        var raw = phoneLocalInput.value;
        var stripped = raw.replace(/[^\d+]/g, '');
        var prefixMatch = stripped.match(/^(?:\+|00)(\d{1,4})/);
        if (prefixMatch) {
          var match = findCountryByDial(prefixMatch[1]);
          if (match) {
            applyDialCode(match.country);
            var stripRe = new RegExp('^\\s*(?:\\+|00)\\d{' + match.dial.length + '}[\\s-]*');
            raw = raw.replace(stripRe, '');
          }
        }
        phoneLocalInput.value = raw.replace(/\D/g, '').slice(0, 12);
      });
    }

    // ---------- Booking window helpers ----------
    function todayMidnight() { return zonedTodayAsLocalDate(visitorTz); }
    function windowEnd() { var d = todayMidnight(); d.setDate(d.getDate() + cfg.daysAhead - 1); return d; }
    function isDateBookable(d) {
      var t = todayMidnight(), end = windowEnd();
      if (d < t || d > end) return false;
      if (cfg.skipWeekday >= 0 && d.getDay() === cfg.skipWeekday) return false;
      return true;
    }
    function dateKey(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    // ---------- Calendar ----------
    function renderCalendar() {
      calRoot.innerHTML = '';

      var header = document.createElement('div');
      header.className = 'hs-cal__header';

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button'; prevBtn.className = 'hs-cal__nav'; prevBtn.textContent = '\u2039';
      var prevMonthLastDay = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), 0);
      prevBtn.disabled = prevMonthLastDay < todayMidnight();
      prevBtn.addEventListener('click', function () { viewMonth.setMonth(viewMonth.getMonth() - 1); renderCalendar(); });

      var label = document.createElement('div');
      label.className = 'hs-cal__month-label';
      label.textContent = viewMonth.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button'; nextBtn.className = 'hs-cal__nav'; nextBtn.textContent = '\u203A';
      var nextMonthFirstDay = new Date(viewMonth.getFullYear(), viewMonth.getMonth() + 1, 1);
      nextBtn.disabled = nextMonthFirstDay > windowEnd();
      nextBtn.addEventListener('click', function () { viewMonth.setMonth(viewMonth.getMonth() + 1); renderCalendar(); });

      header.appendChild(prevBtn); header.appendChild(label); header.appendChild(nextBtn);
      calRoot.appendChild(header);

      var weekdaysRow = document.createElement('div');
      weekdaysRow.className = 'hs-cal__weekdays';
      ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].forEach(function (w) {
        var el = document.createElement('div'); el.className = 'hs-cal__weekday'; el.textContent = w;
        weekdaysRow.appendChild(el);
      });
      calRoot.appendChild(weekdaysRow);

      var grid = document.createElement('div');
      grid.className = 'hs-cal__grid';

      var firstOfMonth = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), 1);
      var startOffset = (firstOfMonth.getDay() + 6) % 7;
      var daysInMonth = new Date(viewMonth.getFullYear(), viewMonth.getMonth() + 1, 0).getDate();

      for (var i = 0; i < startOffset; i++) {
        var empty = document.createElement('div');
        empty.className = 'hs-cal__day hs-cal__day--empty';
        grid.appendChild(empty);
      }

      for (var day = 1; day <= daysInMonth; day++) {
        var thisDate = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), day);
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'hs-cal__day'; btn.textContent = String(day);

        var bookable = isDateBookable(thisDate);
        btn.disabled = !bookable;
        if (selectedDateObj && dateKey(selectedDateObj) === dateKey(thisDate)) btn.setAttribute('data-selected', 'true');

        if (bookable) {
          btn.addEventListener('click', (function (d) {
            return function () { selectedDateObj = d; renderCalendar(); loadDaySlots(d); };
          })(thisDate));
        }
        grid.appendChild(btn);
      }
      calRoot.appendChild(grid);

      if (selectedDateObj && dateKey(selectedDateObj) >= dateKey(new Date(viewMonth.getFullYear(), viewMonth.getMonth(), 1))) {
        var timesWrap = document.createElement('div');
        timesWrap.className = 'hs-cal__times';
        timesWrap.setAttribute('data-times-wrap', '');
        calRoot.appendChild(timesWrap);
        loadDaySlots(selectedDateObj);
      }
    }

    function loadDaySlots(d) {
      var wrap = calRoot.querySelector('[data-times-wrap]');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'hs-cal__times';
        wrap.setAttribute('data-times-wrap', '');
        calRoot.appendChild(wrap);
      }
      wrap.innerHTML = '<p class="hs-cal__times-label">Loading times\u2026</p>';

      var dStr = dateKey(d);
      fetch(endpoint + '/day-slots?date=' + dStr + '&' + cfgQuery + '&tz=' + encodeURIComponent(visitorTz))
        .then(function (r) { return r.json(); })
        .then(function (data) { renderTimeGrid(wrap, data.slots || [], d); })
        .catch(function () { wrap.innerHTML = '<p class="hs-cal__empty-note">Could not load times. Please try again.</p>'; });
    }

    function visitorHour(date) {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: visitorTz }).formatToParts(date);
        var h = Number(parts.find(function (p) { return p.type === 'hour'; }).value);
        return h === 24 ? 0 : h;
      } catch (e) { return date.getHours(); }
    }
    function periodOf(date) {
      var h = visitorHour(date);
      if (h < 12) return 'Morning';
      if (h < 17) return 'Afternoon';
      return 'Evening';
    }
    function localDateOfInstant(date) {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: visitorTz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
      function g(t) { return Number(parts.find(function (p) { return p.type === t; }).value); }
      return new Date(g('year'), g('month') - 1, g('day'));
    }
    function fmtTime(date) {
      return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: visitorTz });
    }
    function fmtDay(date, long) {
      return date.toLocaleDateString(undefined, { weekday: long ? 'long' : 'short', month: 'short', day: 'numeric', timeZone: visitorTz });
    }

    function modeLabel() {
      var m = form.querySelector('input[name="consultation_mode"]:checked');
      return m && m.value === 'video' ? 'Video call' : 'Phone call';
    }

    function updateSlotCard() {
      if (!slotCard) return;
      if (!selectedSlotUtc) { slotCard.hidden = true; return; }
      var end = new Date(selectedSlotUtc.getTime() + cfg.slotMinutes * 60000);
      slotCard.querySelector('[data-sc-day]').textContent = fmtDay(selectedSlotUtc, true);
      slotCard.querySelector('[data-sc-time]').textContent = fmtTime(selectedSlotUtc) + ' \u2013 ' + fmtTime(end);
      slotCard.querySelector('[data-sc-tz]').textContent = 'Your time \u00B7 ' + visitorTz.replace(/_/g, ' ') + ' \u00B7 ' + cfg.slotMinutes + ' min \u00B7 ' + modeLabel();
      var withEl = slotCard.querySelector('[data-sc-with]');
      if (withEl) {
        if (specialist.name) { withEl.textContent = 'With ' + specialist.name + (specialist.title ? ', ' + specialist.title : ''); withEl.hidden = false; }
        else withEl.hidden = true;
      }
      slotCard.hidden = false;
    }
    Array.prototype.forEach.call(form.querySelectorAll('input[name="consultation_mode"]'), function (r) {
      r.addEventListener('change', updateSlotCard);
    });

    function selectSlot(slotDate) {
      selectedSlotUtc = slotDate;
      slotHiddenInput.value = slotDate.toISOString();
      var summaryText = fmtDay(slotDate, false) + ' at ' + fmtTime(slotDate) + ' (' + visitorTz + ')';
      slotSummary.textContent = 'Selected: ' + summaryText;
      dtLabel.textContent = summaryText;
      dtTrigger.setAttribute('data-filled', 'true');
      dtTrigger.removeAttribute('data-invalid');
      if (nextAvailBtn) nextAvailBtn.hidden = true;
      updateSlotCard();
    }

    function clearSlot() {
      selectedSlotUtc = null;
      slotHiddenInput.value = '';
      slotSummary.textContent = 'No time selected yet';
      dtLabel.textContent = 'Select date and time';
      dtTrigger.removeAttribute('data-filled');
      updateSlotCard();
      loadNextAvailable();
    }

    function renderTimeGrid(wrap, slots, d) {
      wrap.innerHTML = '';
      var labelEl = document.createElement('p');
      labelEl.className = 'hs-cal__times-label';
      labelEl.textContent = d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' }) + ' \u2014 your local time (' + visitorTz + ')';
      wrap.appendChild(labelEl);

      if (!slots.length) {
        var note = document.createElement('p');
        note.className = 'hs-cal__empty-note';
        note.textContent = 'No slots configured for this day.';
        wrap.appendChild(note);
        return;
      }

      var shown = ui.hideBooked ? slots.filter(function (s) { return s.available; }) : slots;
      if (!shown.length) {
        var full = document.createElement('p');
        full.className = 'hs-cal__empty-note';
        full.textContent = 'All times on this day are taken \u2014 please pick another date.';
        wrap.appendChild(full);
        return;
      }

      var allChips = [];
      function buildChip(s) {
        var slotDate = new Date(s.slot_utc);
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'hs-cal__time-chip';
        btn.innerHTML = '<span class="hs-cal__time-chip-time">' + fmtTime(slotDate) + '</span>' +
          (ui.hideBooked ? '' : '<span class="hs-cal__time-chip-status">' + (s.available ? 'Available' : 'Booked') + '</span>');
        btn.disabled = !s.available;
        if (selectedSlotUtc && selectedSlotUtc.toISOString() === slotDate.toISOString()) btn.setAttribute('data-selected', 'true');
        if (s.available) {
          btn.addEventListener('click', function () {
            allChips.forEach(function (b) { b.removeAttribute('data-selected'); });
            btn.setAttribute('data-selected', 'true');
            selectSlot(slotDate);
            dtModal.hidden = true;
          });
        }
        allChips.push(btn);
        return btn;
      }

      if (ui.groupSlots) {
        var order = ['Morning', 'Afternoon', 'Evening'];
        var icons = { Morning: '\u2600\uFE0F', Afternoon: '\uD83C\uDF24\uFE0F', Evening: '\uD83C\uDF19' };
        var groups = { Morning: [], Afternoon: [], Evening: [] };
        shown.forEach(function (s) { groups[periodOf(new Date(s.slot_utc))].push(s); });
        order.forEach(function (name) {
          if (!groups[name].length) return;
          var h = document.createElement('p');
          h.className = 'hs-cal__period';
          h.textContent = icons[name] + ' ' + name;
          wrap.appendChild(h);
          var g = document.createElement('div');
          g.className = 'hs-cal__time-grid';
          groups[name].forEach(function (s) { g.appendChild(buildChip(s)); });
          wrap.appendChild(g);
        });
      } else {
        var grid = document.createElement('div');
        grid.className = 'hs-cal__time-grid';
        shown.forEach(function (s) { grid.appendChild(buildChip(s)); });
        wrap.appendChild(grid);
      }
    }

    // ---------- "Next available" quick pick ----------
    var nextAvailSlot = null;
    function loadNextAvailable() {
      if (!ui.showNext || !nextAvailBtn || selectedSlotUtc) return;
      fetch(endpoint + '/available-slots?' + cfgQuery)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var first = data && data.slots && data.slots[0];
          if (!first) { nextAvailBtn.hidden = true; return; }
          nextAvailSlot = new Date(typeof first === 'string' ? first : first.slot_utc);
          if (isNaN(nextAvailSlot.getTime())) { nextAvailBtn.hidden = true; return; }
          nextAvailBtn.querySelector('[data-next-avail-text]').textContent = fmtDay(nextAvailSlot, false) + ' at ' + fmtTime(nextAvailSlot);
          nextAvailBtn.hidden = !!selectedSlotUtc;
        })
        .catch(function () { nextAvailBtn.hidden = true; });
    }
    if (nextAvailBtn) {
      nextAvailBtn.addEventListener('click', function () {
        if (!nextAvailSlot) return;
        selectedDateObj = localDateOfInstant(nextAvailSlot);
        viewMonth = new Date(selectedDateObj.getFullYear(), selectedDateObj.getMonth(), 1);
        selectSlot(nextAvailSlot);
        renderCalendar();
      });
    }

    // ---------- Live field validation ----------
    var liveFields = [];
    if (ui.liveValidation) {
      var nameInput = form.querySelector('input[name="name"]');
      var emailInput = form.querySelector('input[name="email"]');
      [
        { el: nameInput, test: function (v) { return v.trim().length >= 2; }, msg: 'Please enter your full name' },
        { el: emailInput, test: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); }, msg: 'Enter a valid email, e.g. name@example.com' },
        { el: phoneLocalInput, test: function (v) { return v.replace(/\D/g, '').length >= 6; }, msg: 'Enter a valid phone number' }
      ].forEach(function (f) {
        if (!f.el) return;
        f.field = f.el.closest('.hs-consultform__field');
        if (!f.field) return;
        f.hint = document.createElement('small');
        f.hint.className = 'hs-hint';
        f.hint.setAttribute('role', 'status');
        f.field.appendChild(f.hint);
        f.touched = false;
        liveFields.push(f);
        function run() {
          var ok = f.test(f.el.value || '');
          if (!f.touched) return ok;
          f.field.setAttribute('data-state', ok ? 'valid' : 'invalid');
          f.hint.textContent = ok ? '' : f.msg;
          return ok;
        }
        f.run = run;
        f.el.addEventListener('blur', function () { if ((f.el.value || '').length) { f.touched = true; run(); } });
        f.el.addEventListener('input', function () { if (f.touched) run(); });
      });
    }
    function validateLiveFields() {
      var firstBad = null;
      liveFields.forEach(function (f) {
        f.touched = true;
        if (!f.run() && !firstBad) firstBad = f.el;
      });
      return firstBad;
    }

    // ---------- "My booking": the visitor's own booking, private to this browser ----------
    var mbCard = root.querySelector('[data-my-booking-card]');
    function mbEl(sel) { return mbCard.querySelector(sel); }
    function loadMyBooking() {
      if (!mbCard || !myBookingOn) return;
      var saved = mbGet();
      if (!saved || !/^[a-f0-9]{32}$/.test(saved.token || '')) { mbCard.hidden = true; return; }
      fetch(endpoint + '/manage/info?token=' + encodeURIComponent(saved.token))
        .then(function (r) { if (r.status === 404) { mbClear(); return null; } return r.json(); })
        .then(function (info) {
          if (!info || info.status !== 'booked' || new Date(info.slot_utc).getTime() < Date.now() - 30 * 60000) {
            if (info) mbClear();
            mbCard.hidden = true; return;
          }
          renderMyBooking(info, saved.token);
        })
        .catch(function () { mbCard.hidden = true; });
    }

    function hideCard() { mbCard.hidden = true; }

    // ---------- "My bookings" popup: verified by an emailed 6-digit code, shows ALL bookings ----------
    var SESS_KEY = 'hs_consult_session_v1';
    var mybkOpenBtn = root.querySelector('[data-mybk-open]');
    var mybkModal = root.querySelector('[data-mybk-modal]');
    if (mybkOpenBtn && mybkModal) {
      var steps = {
        email: mybkModal.querySelector('[data-mybk-step="email"]'),
        code: mybkModal.querySelector('[data-mybk-step="code"]'),
        list: mybkModal.querySelector('[data-mybk-step="list"]')
      };
      var emailForm = mybkModal.querySelector('[data-mybk-email-form]');
      var emailInput = mybkModal.querySelector('[data-mybk-email]');
      var emailErr = mybkModal.querySelector('[data-mybk-err]');
      var sendBtn = mybkModal.querySelector('[data-mybk-send]');
      var codeForm = mybkModal.querySelector('[data-mybk-code-form]');
      var codeInput = mybkModal.querySelector('[data-mybk-code]');
      var codeErr = mybkModal.querySelector('[data-mybk-err2]');
      var verifyBtn = mybkModal.querySelector('[data-mybk-verify]');
      var sentTo = mybkModal.querySelector('[data-mybk-sent-to]');
      var listEl = mybkModal.querySelector('[data-mybk-list]');
      var pendingEmail = '';

      function sessGet() { try { var v = localStorage.getItem(SESS_KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
      function sessSet(tok) { try { localStorage.setItem(SESS_KEY, JSON.stringify({ session: tok, saved: Date.now() })); } catch (e) {} }
      function sessClear() { try { localStorage.removeItem(SESS_KEY); } catch (e) {} }
      function showStep(name) {
        Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
        if (name === 'email') setTimeout(function () { emailInput.focus(); }, 30);
        if (name === 'code') setTimeout(function () { codeInput.focus(); }, 30);
      }
      function setMsg(el, txt) { el.textContent = txt || ''; el.hidden = !txt; }
      function openMyBookings() {
        mybkModal.hidden = false;
        var saved = sessGet();
        if (saved && /^[a-f0-9]{32}$/.test(saved.session || '')) { loadList(saved.session); }
        else { setMsg(emailErr, ''); showStep('email'); }
      }
      function closeMyBookings() { mybkModal.hidden = true; }
      mybkOpenBtn.addEventListener('click', openMyBookings);
      mybkModal.querySelector('[data-mybk-close]').addEventListener('click', closeMyBookings);
      mybkModal.addEventListener('click', function (e) { if (e.target === mybkModal) closeMyBookings(); });

      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var em = (emailInput.value || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { setMsg(emailErr, 'Please enter a valid email address.'); return; }
        setMsg(emailErr, ''); sendBtn.disabled = true; sendBtn.textContent = 'Checking…';
        fetch(endpoint + '/manage/find', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em }) })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (res.ok) { pendingEmail = em; sentTo.textContent = em; codeInput.value = ''; setMsg(codeErr, ''); showStep('code'); }
            else setMsg(emailErr, res.data.message || 'Something went wrong — please try again.');
          })
          .catch(function () { setMsg(emailErr, 'Something went wrong — please try again.'); })
          .finally(function () { sendBtn.disabled = false; sendBtn.textContent = 'Send code'; });
      });

      codeForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = (codeInput.value || '').replace(/\D/g, '');
        if (code.length !== 6) { setMsg(codeErr, 'Enter the 6-digit code from your email.'); return; }
        setMsg(codeErr, ''); verifyBtn.disabled = true; verifyBtn.textContent = 'Verifying…';
        fetch(endpoint + '/manage/verify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: pendingEmail, code: code }) })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (res.ok && res.data.session) { sessSet(res.data.session); loadList(res.data.session); }
            else setMsg(codeErr, res.data.message || 'That code is not correct.');
          })
          .catch(function () { setMsg(codeErr, 'Something went wrong — please try again.'); })
          .finally(function () { verifyBtn.disabled = false; verifyBtn.textContent = 'Verify'; });
      });
      mybkModal.querySelector('[data-mybk-change]').addEventListener('click', function () { showStep('email'); });

      function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }

      function loadList(session) {
        showStep('list');
        listEl.innerHTML = '';
        listEl.appendChild(el('p', 'hs-mybk-intro', 'Loading your bookings…'));
        fetch(endpoint + '/manage/my?session=' + encodeURIComponent(session))
          .then(function (r) {
            if (r.status === 401) { sessClear(); setMsg(emailErr, 'Your session ended. Please verify your email again.'); showStep('email'); return null; }
            return r.json();
          })
          .then(function (data) { if (data) renderList(data.bookings || [], session, data.name); })
          .catch(function () { listEl.innerHTML = ''; listEl.appendChild(el('p', 'hs-mybk-msg', 'Could not load your bookings. Please try again.')); });
      }

      function renderList(bookings, session, name) {
        listEl.innerHTML = '';
        if (name) listEl.appendChild(el('p', 'hs-mybk-hello', 'Hi ' + name + ' 👋'));
        if (!bookings.length) { listEl.appendChild(el('p', 'hs-mybk-intro', 'No bookings yet.')); return; }
        var upcoming = bookings.filter(function (b) { return b.status === 'upcoming'; });
        var past = bookings.filter(function (b) { return b.status !== 'upcoming'; });
        function section(title, items, empty) {
          listEl.appendChild(el('p', 'hs-mybk-section', title + (items.length ? ' (' + items.length + ')' : '')));
          if (!items.length) { listEl.appendChild(el('p', 'hs-mybk-empty', empty)); return; }
          items.forEach(function (b) { listEl.appendChild(bookingCard(b, session)); });
        }
        section('Upcoming', upcoming, 'No upcoming bookings.');
        if (past.length) section('Completed & cancelled', past, '');
        var out = el('button', 'hs-mybk-link', 'Not you? Sign out');
        out.type = 'button';
        out.addEventListener('click', function () { sessClear(); listEl.innerHTML = ''; emailInput.value = ''; setMsg(emailErr, ''); showStep('email'); });
        listEl.appendChild(out);
      }

      function bookingCard(b, session) {
        var start = new Date(b.slot_utc), end = new Date(start.getTime() + (b.slot_minutes || cfg.slotMinutes) * 60000);
        var card = el('div', 'hs-mybk-card hs-mybk-card--' + b.status);
        var top = el('div', 'hs-mybk-card__top');
        top.appendChild(el('span', 'hs-mybk-chip hs-mybk-chip--' + b.status, b.status === 'upcoming' ? 'Upcoming' : (b.status === 'completed' ? 'Completed' : 'Cancelled')));
        top.appendChild(el('span', 'hs-mybk-card__mode', b.mode === 'video' ? 'Video call' : 'Phone call'));
        card.appendChild(top);
        card.appendChild(el('p', 'hs-mybk-card__day', fmtDay(start, true)));
        card.appendChild(el('p', 'hs-mybk-card__time', fmtTime(start) + ' – ' + fmtTime(end)));
        if (b.specialist_name) card.appendChild(el('p', 'hs-mybk-card__spec', 'With ' + b.specialist_name + (b.specialist_title ? ', ' + b.specialist_title : '')));
        if (b.status === 'upcoming') {
          var actions = el('div', 'hs-mybk-card__actions');
          if (b.meet_link) { var j = el('a', 'hs-success__btn hs-success__btn--primary', 'Join Google Meet'); j.href = b.meet_link; j.target = '_blank'; j.rel = 'noopener'; actions.appendChild(j); }
          if (b.can_change) {
            var row = el('div', 'hs-mybk-card__row');
            if (b.reschedules_left > 0) { var rs = el('a', 'hs-success__btn', 'Reschedule'); rs.href = endpoint + '/manage?token=' + b.token; rs.target = '_blank'; rs.rel = 'noopener'; row.appendChild(rs); }
            var cn = el('button', 'hs-success__btn hs-mybook__cancel', 'Cancel'); cn.type = 'button';
            row.appendChild(cn); actions.appendChild(row);
            var conf = el('div', 'hs-mybk-confirm'); conf.hidden = true;
            conf.appendChild(el('p', null, 'Cancel this consultation?'));
            var crow = el('div', 'hs-mybk-card__row');
            var yes = el('button', 'hs-success__btn hs-mybk-danger', 'Yes, cancel'); yes.type = 'button';
            var no = el('button', 'hs-success__btn', 'Keep it'); no.type = 'button';
            crow.appendChild(yes); crow.appendChild(no); conf.appendChild(crow);
            cn.addEventListener('click', function () { conf.hidden = false; });
            no.addEventListener('click', function () { conf.hidden = true; });
            yes.addEventListener('click', function () {
              yes.disabled = true; yes.textContent = 'Cancelling…';
              fetch(endpoint + '/manage/cancel', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: b.token }) })
                .then(function (r) {
                  if (r.ok) {
                    var saved = mbGet(); if (saved && saved.token === b.token) mbClear();
                    if (mbCard) mbCard.hidden = true;
                    loadNextAvailable(); if (selectedDateObj) loadDaySlots(selectedDateObj);
                    loadList(session);
                  } else { yes.disabled = false; yes.textContent = 'Yes, cancel'; conf.appendChild(el('p', 'hs-mybk-msg', 'This booking can no longer be changed online. Please reply to your confirmation email.')); }
                })
                .catch(function () { yes.disabled = false; yes.textContent = 'Yes, cancel'; });
            });
            card.appendChild(actions); card.appendChild(conf);
            return card;
          }
          if (b.reason === 'cutoff') actions.appendChild(el('p', 'hs-mybk-note', 'Changes are closed within ' + b.cutoff_hours + ' hours of the call.'));
          card.appendChild(actions);
        }
        return card;
      }

      // Opened from the "Open my bookings" email link on any device.
      try {
        var bkUrl = new URL(window.location.href);
        var bkTok = bkUrl.searchParams.get('hs_bk');
        if (bkTok && /^[a-f0-9]{32}$/.test(bkTok)) {
          sessSet(bkTok);
          bkUrl.searchParams.delete('hs_bk');
          window.history.replaceState(null, '', bkUrl.pathname + bkUrl.search + bkUrl.hash);
          setTimeout(function () { openMyBookings(); if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 600);
        }
      } catch (e) {}
    }
    function renderMyBooking(info, token) {
      var start = new Date(info.slot_utc), end = new Date(start.getTime() + (info.slot_minutes || cfg.slotMinutes) * 60000);
      mbEl('[data-mb-day]').textContent = fmtDay(start, true);
      mbEl('[data-mb-time]').textContent = fmtTime(start) + ' \u2013 ' + fmtTime(end);
      mbEl('[data-mb-meta]').textContent = visitorTz.replace(/_/g, ' ') + ' \u00B7 ' + (info.mode === 'video' ? 'Video call' : 'Phone call');
      var specEl = mbEl('[data-mb-spec]');
      if (info.specialist_name) { specEl.textContent = 'With ' + info.specialist_name + (info.specialist_title ? ', ' + info.specialist_title : ''); specEl.hidden = false; }
      else specEl.hidden = true;
      var meetBtn = mbEl('[data-mb-meet]');
      if (info.meet_link) { meetBtn.href = info.meet_link; meetBtn.hidden = false; } else meetBtn.hidden = true;
      var resched = mbEl('[data-mb-resched]');
      resched.href = endpoint + '/manage?token=' + token;
      var cancelBtn = mbEl('[data-mb-cancel]');
      var note = mbEl('[data-mb-note]');
      note.hidden = true;
      resched.hidden = !(info.can_change && info.reschedules_left > 0);
      cancelBtn.hidden = !info.can_change;
      if (!info.can_change) {
        note.textContent = info.reason === 'cutoff'
          ? 'Changes are closed within ' + info.cutoff_hours + ' hours of the call. Reply to your confirmation email if you need help.'
          : 'Online changes are not available for this booking. Reply to your confirmation email if you need help.';
        note.hidden = false;
      }
      var confirmBox = mbEl('[data-mb-confirm]');
      confirmBox.hidden = true;
      cancelBtn.onclick = function () { confirmBox.hidden = false; };
      mbEl('[data-mb-no]').onclick = function () { confirmBox.hidden = true; };
      mbEl('[data-mb-yes]').onclick = function () {
        var yes = mbEl('[data-mb-yes]'); yes.disabled = true; yes.textContent = 'Cancelling\u2026';
        fetch(endpoint + '/manage/cancel', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: token }) })
          .then(function (r) {
            if (r.ok) {
              mbClear();
              mbCard.querySelector('.hs-mybooking__body').hidden = true;
              mbCard.querySelector('.hs-mybooking__actions').hidden = true;
              confirmBox.hidden = true;
              note.textContent = 'Your booking has been cancelled. We\u2019ve emailed you a confirmation. You can book a new time below.';
              note.hidden = false;
              loadNextAvailable();
              if (selectedDateObj) loadDaySlots(selectedDateObj);
            } else {
              note.textContent = 'This booking can no longer be changed online. Please reply to your confirmation email.';
              note.hidden = false; confirmBox.hidden = true;
            }
          })
          .catch(function () { note.textContent = 'Something went wrong \u2014 please try again.'; note.hidden = false; })
          .finally(function () { yes.disabled = false; yes.textContent = 'Yes, cancel'; });
      };
      mbCard.querySelector('.hs-mybooking__body').hidden = false;
      mbCard.querySelector('.hs-mybooking__actions').hidden = false;
      mbCard.hidden = false;
      if (cameFromLink) { cameFromLink = false; if (mbCard.scrollIntoView) mbCard.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }

    // ---------- Booking-confirmed screen ----------
    function pad(n) { return String(n).padStart(2, '0'); }
    function icsStamp(date) {
      return date.getUTCFullYear() + pad(date.getUTCMonth() + 1) + pad(date.getUTCDate()) + 'T' +
        pad(date.getUTCHours()) + pad(date.getUTCMinutes()) + '00Z';
    }
    function icsEscape(t) { return String(t).replace(/\\/g, '\\\\').replace(/;/g, '\;').replace(/,/g, '\\,').replace(/\n/g, '\\n'); }

    function showSuccess(data, booked) {
      bodyEl.hidden = true;
      successEl.hidden = false;
      var start = booked.start, end = new Date(start.getTime() + cfg.slotMinutes * 60000);
      var meet = data && data.meet_link ? data.meet_link : null;
      var manage = data && data.manage_url ? data.manage_url : null;

      function setText(sel, txt) { var el = successEl.querySelector(sel); if (el) el.textContent = txt; }
      setText('[data-sc-when-day]', fmtDay(start, true));
      setText('[data-sc-when-time]', fmtTime(start) + ' \u2013 ' + fmtTime(end));
      setText('[data-sc-when-tz]', visitorTz.replace(/_/g, ' '));
      setText('[data-sc-mode]', booked.mode === 'video' ? 'Video call' + (meet ? ' (Google Meet)' : '') : 'Phone call' + (booked.phone ? ' \u2014 we\u2019ll call ' + booked.phone : ''));
      setText('[data-sc-email]', booked.email || '');

      var specRow = successEl.querySelector('[data-sc-spec-row]');
      if (specRow) {
        if (specialist.name) { setText('[data-sc-spec]', specialist.name); setText('[data-sc-spec-title]', specialist.title); specRow.hidden = false; }
        else specRow.hidden = true;
      }
      if (manage && myBookingOn) {
        var tk = (manage.split('token=')[1] || '').split('&')[0];
        if (/^[a-f0-9]{32}$/.test(tk)) mbSet({ token: tk, saved: Date.now() });
      }

      var meetBtn = successEl.querySelector('[data-sc-meet]');
      if (meetBtn) { if (meet) { meetBtn.href = meet; meetBtn.hidden = false; } else meetBtn.hidden = true; }
      var manageBtn = successEl.querySelector('[data-sc-manage]');
      if (manageBtn) { if (manage) { manageBtn.href = manage; manageBtn.hidden = false; } else manageBtn.hidden = true; }

      var calWrap = successEl.querySelector('[data-sc-cal-wrap]');
      if (calWrap) {
        if (!ui.showAddToCal) { calWrap.hidden = true; }
        else {
          calWrap.hidden = false;
          var details = 'Free hearing consultation with HearSilk (' + (booked.mode === 'video' ? 'video call' : 'phone call') + ').' +
            (meet ? '\nJoin: ' + meet : '') + (manage ? '\nReschedule or cancel: ' + manage : '');
          var gUrl = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(ui.calTitle) +
            '&dates=' + icsStamp(start) + '/' + icsStamp(end) +
            '&details=' + encodeURIComponent(details) + (meet ? '&location=' + encodeURIComponent(meet) : '');
          var gBtn = successEl.querySelector('[data-sc-gcal]');
          if (gBtn) gBtn.href = gUrl;
          var icsBtn = successEl.querySelector('[data-sc-ics]');
          if (icsBtn) {
            icsBtn.onclick = function () {
              var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//HearSilk//Consultation//EN', 'BEGIN:VEVENT',
                'UID:' + (data && data.id ? data.id : String(start.getTime())) + '@hearsilk.com',
                'DTSTAMP:' + icsStamp(new Date()), 'DTSTART:' + icsStamp(start), 'DTEND:' + icsStamp(end),
                'SUMMARY:' + icsEscape(ui.calTitle), 'DESCRIPTION:' + icsEscape(details),
                meet ? 'LOCATION:' + icsEscape(meet) : 'LOCATION:Phone',
                'BEGIN:VALARM', 'TRIGGER:-PT30M', 'ACTION:DISPLAY', 'DESCRIPTION:Reminder', 'END:VALARM',
                'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
              var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
              var a = document.createElement('a');
              a.href = URL.createObjectURL(blob); a.download = 'hearsilk-consultation.ics';
              document.body.appendChild(a); a.click();
              setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
            };
          }
        }
      }
      var card = root.querySelector('.hs-consultform__card');
      if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ---------- FAQ slider ----------
    var faqWrap = root.querySelector('[data-faq-wrap]');
    var faqSlides = Array.prototype.slice.call(root.querySelectorAll('[data-faq-slide]'));
    var faqProgressBar = root.querySelector('[data-faq-progress-bar]');
    var messageField = root.querySelector('[data-message-field]');
    var faqAnswers = [];
    var faqIndex = 0;

    function showFaqSlide(idx) {
      faqSlides.forEach(function (slide, i) {
        slide.setAttribute('data-active', i === idx ? 'true' : 'false');
      });
      if (faqProgressBar) {
        faqProgressBar.style.width = (idx / faqSlides.length * 100) + '%';
      }
    }

    function advanceFaq(answer, files) {
      var slide = faqSlides[faqIndex];
      var item = { question: slide.getAttribute('data-faq-question'), answer: answer };
      if (files && files.length) item.files = files;
      faqAnswers.push(item);
      faqIndex++;
      if (faqIndex >= faqSlides.length) {
        if (faqProgressBar) faqProgressBar.style.width = '100%';
        if (faqWrap) faqWrap.hidden = true;
        if (messageField) messageField.hidden = false;
      } else {
        showFaqSlide(faqIndex);
      }
    }

    var FAQ_MAX_FILES = 3;
    var FAQ_MAX_BYTES = 5 * 1024 * 1024;
    var FAQ_EXT = /\.(pdf|jpe?g|png|webp|heic|heif)$/i;

    function setupFaqSlide(slide) {
      var type = slide.getAttribute('data-faq-type') || 'single';
      var opts = Array.prototype.slice.call(slide.querySelectorAll('[data-faq-opt]'));
      var otherInput = slide.querySelector('[data-faq-other-input]');
      var otherBtn = slide.querySelector('[data-faq-other-submit]');
      if (otherInput) {
        otherInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); if (otherBtn) otherBtn.click(); }
        });
      }

      // ----- multiple choice -----
      if (type === 'multiple') {
        var cont = slide.querySelector('[data-faq-multi-continue]');
        var optsWrap = opts.length ? opts[0].parentNode : slide;
        var picked = function () {
          return Array.prototype.slice.call(slide.querySelectorAll('[data-faq-opt][data-picked="true"]'));
        };
        var refresh = function () { if (cont) cont.disabled = picked().length === 0; };
        var bindToggle = function (btn) {
          btn.addEventListener('click', function () {
            if (btn.getAttribute('data-picked') === 'true') btn.removeAttribute('data-picked');
            else btn.setAttribute('data-picked', 'true');
            refresh();
          });
        };
        opts.forEach(bindToggle);
        if (otherBtn) {
          otherBtn.addEventListener('click', function () {
            var val = (otherInput.value || '').trim();
            if (!val) { otherInput.focus(); return; }
            var dup = false;
            slide.querySelectorAll('[data-faq-opt]').forEach(function (b) {
              if (b.getAttribute('data-faq-opt').toLowerCase() === val.toLowerCase()) { dup = true; b.setAttribute('data-picked', 'true'); }
            });
            if (!dup) {
              var chip = document.createElement('button');
              chip.type = 'button';
              chip.className = 'hs-faq__opt';
              chip.setAttribute('data-faq-opt', val);
              chip.setAttribute('data-picked', 'true');
              chip.textContent = val;
              var firstOpt = slide.querySelector('[data-faq-opt]');
              if (firstOpt && firstOpt.parentNode) firstOpt.parentNode.appendChild(chip);
              else slide.insertBefore(chip, otherInput.parentNode);
              bindToggle(chip);
            }
            otherInput.value = '';
            refresh();
          });
        }
        if (cont) {
          cont.addEventListener('click', function () {
            var vals = picked().map(function (b) { return b.getAttribute('data-faq-opt'); });
            if (!vals.length) return;
            advanceFaq(vals.join(', '));
          });
        }
        refresh();
        return;
      }

      // ----- single / single + upload -----
      var trigger = (slide.getAttribute('data-upload-trigger') || '').trim().toLowerCase();
      var panel = slide.querySelector('[data-faq-upload]');
      var required = slide.getAttribute('data-upload-required') === 'true';
      var fileInput = slide.querySelector('[data-faq-file]');
      var list = slide.querySelector('[data-faq-files]');
      var errEl = slide.querySelector('[data-faq-upload-err]');
      var upCont = slide.querySelector('[data-faq-upload-continue]');
      var upSkip = slide.querySelector('[data-faq-upload-skip]');
      var uploaded = [];   // {id,name,size,type}
      var busy = 0;
      var pickedAnswer = '';
      var uploadsDown = false;

      function showErr(msg) { if (!errEl) return; errEl.textContent = msg || ''; errEl.hidden = !msg; }
      function syncCont() {
        if (!upCont) return;
        upCont.disabled = busy > 0 || (required && !uploadsDown && uploaded.length === 0);
      }
      function renderRow(f) {
        var li = document.createElement('li');
        li.className = 'hs-faq__file';
        var nm = document.createElement('span');
        nm.className = 'hs-faq__file-name';
        nm.textContent = f.name;
        var st = document.createElement('span');
        st.className = 'hs-faq__file-status';
        st.textContent = 'Uploading…';
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'hs-faq__file-remove';
        rm.setAttribute('aria-label', 'Remove ' + f.name);
        rm.textContent = '×';
        li.appendChild(nm); li.appendChild(st); li.appendChild(rm);
        list.appendChild(li);
        return { li: li, st: st, rm: rm };
      }
      function uploadOne(file) {
        var row = renderRow(file);
        busy++; syncCont();
        var rec = null;
        row.rm.addEventListener('click', function () {
          if (rec) uploaded = uploaded.filter(function (x) { return x !== rec; });
          row.li.parentNode && row.li.parentNode.removeChild(row.li);
          showErr(''); syncCont();
        });
        var fd = new FormData();
        fd.append('file', file);
        fetch(endpoint + '/upload', { method: 'POST', body: fd })
          .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
          .then(function (res) {
            if (res.status === 200 && res.body && res.body.ok) {
              rec = { id: res.body.id, name: res.body.name || file.name, size: res.body.size || file.size, type: res.body.type || file.type };
              uploaded.push(rec);
              row.st.textContent = 'Uploaded ✓';
              row.li.setAttribute('data-ok', 'true');
            } else {
              if (res.status === 503) uploadsDown = true;
              row.li.parentNode && row.li.parentNode.removeChild(row.li);
              showErr((res.body && res.body.error) || 'Upload failed. Please try again or skip.');
            }
          })
          .catch(function () {
            row.li.parentNode && row.li.parentNode.removeChild(row.li);
            showErr('Upload failed. Check your connection and try again.');
          })
          .then(function () { busy--; syncCont(); });
      }

      if (fileInput) {
        fileInput.addEventListener('change', function () {
          showErr('');
          var files = Array.prototype.slice.call(fileInput.files || []);
          fileInput.value = '';
          files.forEach(function (f) {
            var count = uploaded.length + busy;
            if (count >= FAQ_MAX_FILES) { showErr('You can upload up to ' + FAQ_MAX_FILES + ' files.'); return; }
            if (!FAQ_EXT.test(f.name)) { showErr('Only PDF or image files (JPG, PNG, WEBP, HEIC) are allowed.'); return; }
            if (f.size > FAQ_MAX_BYTES) { showErr(f.name + ' is larger than 5 MB.'); return; }
            uploadOne(f);
          });
        });
      }
      if (upCont) {
        upCont.addEventListener('click', function () {
          if (busy > 0) return;
          advanceFaq(pickedAnswer, uploaded.slice());
        });
      }
      if (upSkip) {
        upSkip.addEventListener('click', function () {
          if (busy > 0) return;
          advanceFaq(pickedAnswer);
        });
      }

      opts.forEach(function (optBtn) {
        optBtn.addEventListener('click', function () {
          opts.forEach(function (b) { b.removeAttribute('data-picked'); });
          optBtn.setAttribute('data-picked', 'true');
          var ans = optBtn.getAttribute('data-faq-opt');
          if (panel && trigger && ans.trim().toLowerCase() === trigger) {
            pickedAnswer = ans;
            panel.hidden = false;
            syncCont();
            return;
          }
          if (panel) panel.hidden = true;
          setTimeout(function () { advanceFaq(ans); }, 180);
        });
      });
      if (otherBtn) {
        otherBtn.addEventListener('click', function () {
          var val = (otherInput.value || '').trim();
          if (!val) { otherInput.focus(); return; }
          advanceFaq(val);
        });
      }
    }

    if (faqSlides.length) {
      showFaqSlide(0);
      faqSlides.forEach(setupFaqSlide);
    }

    // ---------- Analytics context ----------
    // Real source saved earlier by the "hs_touch" snippet in theme.liquid (used only when this visit has no source of its own).
    function readStoredTouch() {
      try {
        var t = JSON.parse(window.localStorage.getItem('hs_touch') || 'null');
        if (!t || !t.ts || (Date.now() - t.ts) > 30 * 86400000) return null;
        var sp = new URLSearchParams();
        ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (t[k]) sp.set(k, t[k]); });
        if (t.gclid) sp.set('gclid', '1');
        if (t.fbclid) sp.set('fbclid', '1');
        return { params: sp, referrer: t.referrer || '' };
      } catch (e) { return null; }
    }
    function detectTrafficSource() {
      var params = new URLSearchParams(window.location.search);
      var ref = document.referrer;
      var refIsOwn = false;
      try { refIsOwn = !!ref && new URL(ref).hostname.replace(/^www\./, '') === window.location.hostname.replace(/^www\./, ''); } catch (e) { /* ignore */ }
      if (!params.get('utm_source') && !params.get('gclid') && !params.get('fbclid') && (!ref || refIsOwn)) {
        var stored = readStoredTouch();
        if (stored) { params = stored.params; ref = stored.referrer; }
      }
      var utmSource = params.get('utm_source');
      var utmMedium = params.get('utm_medium');
      var utmCampaign = params.get('utm_campaign');
      if (params.get('gclid')) return { source: 'google_ads', medium: 'paid', campaign: utmCampaign };
      if (params.get('fbclid')) return { source: 'facebook_ads', medium: 'paid', campaign: utmCampaign };
      if (utmSource) return { source: utmSource, medium: utmMedium || 'unknown', campaign: utmCampaign };
      if (!ref) return { source: 'direct', medium: 'none', campaign: null };
      try {
        var refHost = new URL(ref).hostname.replace(/^www\./, '');
        var thisHost = window.location.hostname.replace(/^www\./, '');
        if (refHost === thisHost) return { source: 'internal', medium: 'site', campaign: null };
        if (/google\./.test(refHost)) return { source: 'google', medium: 'organic', campaign: null };
        if (/bing\./.test(refHost)) return { source: 'bing', medium: 'organic', campaign: null };
        if (/facebook\.|instagram\./.test(refHost)) return { source: refHost, medium: 'social', campaign: null };
        return { source: refHost, medium: 'referral', campaign: null };
      } catch (e) { return { source: 'unknown', medium: 'unknown', campaign: null }; }
    }
    function detectDeviceType() {
      var ua = navigator.userAgent || '';
      if (/tablet|ipad/i.test(ua)) return 'tablet';
      if (/mobile|android|iphone/i.test(ua)) return 'mobile';
      return 'desktop';
    }
    var analyticsContext = {
      trafficSource: detectTrafficSource(),
      deviceType: detectDeviceType(),
      landingPage: window.location.href,
      referrer: document.referrer || null,
      language: navigator.language || null,
      browserTimezone: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) { return null; } })(),
    visitorId: (function () { try { var m = document.cookie.match(/(?:^|; )hs_vid=([^;]+)/); return m ? decodeURIComponent(m[1]).slice(0, 64) : null; } catch (e) { return null; } })()
    };

    // ---------- Submit ----------
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      if (ui.liveValidation) {
        var badEl = validateLiveFields();
        if (badEl) { badEl.focus(); return; }
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var phoneDigitsCount = (phoneLocalInput.value || '').replace(/\D/g, '').length;
      if (phoneDigitsCount < 6) {
        errorEl.textContent = 'Please enter a valid phone number.';
        errorEl.hidden = false;
        phoneLocalInput.focus();
        return;
      }

      if (!selectedSlotUtc) {
        errorEl.textContent = 'Please select a date and time.';
        errorEl.hidden = false;
        dtTrigger.setAttribute('data-invalid', 'true');
        dtTrigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (faqSlides.length && faqAnswers.length < faqSlides.length) {
        errorEl.textContent = 'Please answer all questions above.';
        errorEl.hidden = false;
        faqWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var fd = new FormData(form);
      var localPhone = (fd.get('phone_local') || '').toString().trim();
      var payload = {
        form_type: formType,
        name: fd.get('name') || null,
        email: fd.get('email') || null,
        phone: localPhone ? ('+' + DIAL_CODES[currentDialCountry] + ' ' + localPhone) : null,
        message: fd.get('message') || null,
        consultation_mode: fd.get('consultation_mode') || null,
        slot_utc: selectedSlotUtc.toISOString(),
        visitor_timezone: visitorTz,
        business_tz: cfg.businessTz,
        faq_answers: faqAnswers,
        page_url: window.location.href,
        context: analyticsContext,
        manage_settings: manageSettings,
        specialist: specialist.name ? specialist : undefined,
        booking_config: {
          slot_minutes: cfg.slotMinutes,
          start_hour: cfg.startHour,
          end_hour: cfg.endHour,
          days_ahead: cfg.daysAhead,
          skip_weekday: isNaN(cfg.skipWeekday) ? -1 : cfg.skipWeekday,
          min_lead_minutes: cfg.minLeadMinutes
        }
      };
      var bookedSnapshot = {
        start: selectedSlotUtc,
        mode: payload.consultation_mode,
        phone: payload.phone,
        email: payload.email
      };

      submitBtn.disabled = true;
      var originalLabel = submitBtn.textContent;
      submitBtn.classList.add('is-loading');
      submitBtn.innerHTML = '<span class="hs-spinner" aria-hidden="true"></span><span>Booking\u2026</span>';

      fetch(endpoint + '/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.status === 409) {
            return res.json().then(function (data) { throw { conflict: true, message: data.message }; });
          }
          if (!res.ok) throw new Error('Request failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var successType = root.getAttribute('data-success-type');
          var redirectUrl = root.getAttribute('data-redirect-url');
          if (successType === 'redirect' && redirectUrl) { window.location.href = redirectUrl; return; }
          showSuccess(data || {}, bookedSnapshot);
        })
        .catch(function (err) {
          if (err && err.conflict) {
            errorEl.textContent = err.message || 'That slot was just taken — please pick another time.';
            errorEl.hidden = false;
            clearSlot();
            if (selectedDateObj) loadDaySlots(selectedDateObj);
          } else {
            errorEl.textContent = 'Something went wrong — please try again.';
            errorEl.hidden = false;
            console.error('HearSilk consultation form submit error:', err);
          }
        })
        .finally(function () {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          submitBtn.textContent = originalLabel;
        });
    });
  }

  document.querySelectorAll('.hs-consultform').forEach(initForm);
})();